<db-dialog-wrapper [dialog]="this" [width]="'620px'" [height]="'auto'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="add-payment-method">
    <div class="add-payment-method__body">
      <db-payment-method [checkout]="checkout"
                         [stripe]="stripe"
                         (onPaymentMethodSubmit)="onPaymentMethodSubmit()"
                         (onLoadingChange)="onLoadingChange($event)"
                         [userSubscription]="userSubscription"
                         [isPayPalProvider]="isPayPalProvider"
                         [confirmPayPalPayment]="confirmPayPalPayment"></db-payment-method>
    </div>
    <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
  </div>
</db-dialog-wrapper>
